<template>
  <div>
    <i
      class="help-back hkfi-close-thin fs-24"
      :style="closeIconStyle"
      @click="handleBackClick"
    ></i>
    <iframe
      v-if="showIframe"
      class="help-frame"
      frameBorder="0"
      :src="getSrcUrl"
    />
    <contact-details v-else :moduleProps="moduleProps" />
  </div>
</template>

<script>
import ContactDetails from "./ContactDetails.vue";
export default {
  name: "Help",
  props: ["moduleProps"],
  components: { ContactDetails },
  data() {
    return {
      modulePropsData: {},
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    handleBackClick() {
      history.back();
    },
  },
  computed: {
    getSrcUrl() {
      return this.modulePropsData?.helpUrl;
    },
    showIframe() {
      return this.modulePropsData?.helpUrl?.length > 0;
    },
  },
};
</script>
